// extracted by mini-css-extract-plugin
export default {"container":"s01_container__S-dFW","title":"s01_title__EnRo+"};